(function () {
    window.Dashboard = window.Dashboard || {};
    window.Dashboard.Models = window.Dashboard.Models || {};
    window.Dashboard.Models.Lookups = window.Dashboard.Models.Lookups || {};

    window.Dashboard.Permissions = {
        DashboardAccess: "DashboardAccess",
        ManageCampaigns: "ManageCampaigns",
        StoreSettings: "StoreSettings"
    };

    window.Dashboard.Events = {
        UserContextChanged: "UserContextChanged",
        UserContextNotSet: "UserContextNotSet",
        CampaignSelected: "CampaignSelected",
        CampaignUpdated: "CampaignUpdated"
    };

    window.Dashboard.Campaigns = {
        ListCampaigns: "ListCampaigns",
        ThirtyDayWinback: "ThirtyDayWinback",
        OfflineToOnline: "OfflineToOnline",
        BiggerOrders: "BiggerOrders"
    };

    window.Dashboard.StoreState = {
        Unpublished: 1,
        Testing: 2,
        Live: 3,
        Invalid: 4,
        Unavailable: 5
    };

    window.Dashboard.Subscriptions = {
        YumbiCampaigns: "Yumbi Campaigns"
    };

    window.Dashboard.ContextTypes = {
        BrandContext: "BrandContext",
        CallCenterContext: "CallCenterContext",
        StoreContext: "StoreContext",
        GroupContext: "GroupContext",
        ProvinceContext: "ProvinceContext"
    };

    window.Dashboard.DisplayContextTypes = {
        Restaurant: "Restaurant",
        CallCenter: "CallCenter",
        Brand: "Brand"
    };

    window.Dashboard.HttpStatusCodes = {
        Unauthorized: 401,
        Forbidden: 403,
        Conflict: 409,
        PreconditionFailed: 412,
        NetworkError: -1
    };

    window.Dashboard.CreditCardPaymentStates = {
        Pending: 1,
        Paid: 2,
        Reversed: 3,
        Declined: 4,
        Refunding: 5
    };

    window.Dashboard.VoucherStatus = {
        Evaluated: 1,
        Redeemed: 2,
        Reversed: 3,
        Reversing: 4
    };

    window.Dashboard.CommunicationMessageType = {
        SMS: 1,
        PushNotification: 2,
        Email: 3,
        CustomerFeedback: 4,
        CustomerRating: 5,
        Inbox: 6
    };

    window.Dashboard.PushNotificationMessagePart = {
        PushNotification: 1,
        InboxBlurb: 2,
        InboxTemplate: 3
    };

    window.Dashboard.OrderPaymentType = {
        Unknown: 0,
        PayInStore: 1,
        PayOnline: 2,
        CreditCArdOnDelivery: 3,
        CashOnDelivery: 4,
        MobileMoney: 5
    };

    window.Dashboard.OrderChannels = {
        Unknown: 0,
        Website: 1,
        CallCenter: 2,
        iOS: 3,
        Android: 4
    };

    window.Dashboard.OrderAcceptedMethod = {
        GSM: 1,
        POS: 2,
        Web: 3
    };

    window.Dashboard.NgTableParams = {
        InitialCount: 10,
        ItemCounts: [ 10, 25, 50, 100, 200, 500 ]
    };

    window.Dashboard.LiveChat = {
        userInformation: "/Admin/Users/ManageUser/",
        storeInformation: "/Application/Restaurants/EditRestaurant/",
    }

    window.Dashboard.Models.Lookups.CampaignTemplateStates = {
        Unknown: 0,
        Draft: 1,
        InReview: 2,
        Published: 3,
        Archived: 4
    };

    window.Dashboard.Models.RoleLookup = {
        SystemAdministrator: 1000,
        ReportioUser: 1001,
        BrandExecutive: 1002,
        RegionalExecutive: 1003,
        OperationsManager: 1004,
        Franchisee: 1005,
        FranchiseManager: 1006,
        AreaManager: 1007,
        RestaurantManager: 1008,
        CallCenterManager: 1009,
        CallCenterAgent: 1010,
        OperationsAdministrator: 1011,
        OperationsMenuManager: 1012,
        OperationsRestaurantManager: 1013,
        AuraSupport: 1017,
        ApiUser: 1018,
        InternalUser: 1019,
        BrandMarketer: 1020,
        VouchersAdmin: 1021,
        EditActiveVouchers: 1022,
        OrderUpUser: 1023,
        BrandCustomerSupportAgent: 1024,
        RestaurantLevelTestUser: 1025,
        BrandAdmin: 1026,
        BrandManager: 1027,
        RestaurantAccountOwner: 1028,
    }

    window.Dashboard.Models.Lookups.CampaignTargetSourceStatuses = {
        All: null,
        Test: 1,
        Live: 2,
        Archived: 3
    };

    window.Dashboard.Models.Lookups.CampaignLevelNames = {
        1: "All",
        2: "Brand",
        3: "Store"
    };

    window.Dashboard.Models.Lookups.CampaignLevels = {
        All: 1,
        Brand: 2,
        Store: 3
    };

    window.Dashboard.Models.Lookups.CampaignLevelsWithoutAll = {
        Brand: 2,
        Store: 3
    };

    window.Dashboard.Constants = {
        EmptyGuid: "00000000-0000-0000-0000-000000000000"
    }
})();
